

import React, { useState } from 'react';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from '@/shared/ui/dialog';
import { Button } from '@/shared/ui/button';
import { Plus } from 'lucide-react';
import AddUserForm from './AddUserForm';
import { useUsers } from '../hooks/useUsers';
import { useSupabaseAuth } from '@/shared/hooks/useSupabaseAuth';
import { UserRole } from '@/features/users/types';

/**
 * ユーザー追加ダイアログ
 * @returns ユーザー追加ダイアログ
 */
export const AddUserDialog: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { addUser } = useUsers();
    const { isAdmin } = useSupabaseAuth();

    /**
     * ユーザーを保存する
     * @param userData ユーザーデータ
     */
    const handleSave = async (userData: {
        username: string;
        name: string;
        email: string;
        password: string;
        role: UserRole;
        is_active: boolean;
        craftsman_id: string | null;
    }) => {
        await addUser(userData);
        setIsOpen(false);
    };

    // 管理者権限がない場合はボタンを表示しない
    if (!isAdmin) {
        return null;
    }

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger asChild>
                <Button>
                    <Plus className="h-4 w-4 mr-2" />
                    新規ユーザー追加
                </Button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-[500px] max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle>新規ユーザー追加</DialogTitle>
                    <DialogDescription>
                        システムに新しいユーザーを追加します。ユーザー名、氏名、メールアドレス、パスワード、権限を設定してください。
                    </DialogDescription>
                </DialogHeader>
                {isOpen && (
                    <AddUserForm
                        onClose={() => setIsOpen(false)}
                        onSave={handleSave}
                    />
                )}
            </DialogContent>
        </Dialog>
    );
}; 